var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPt = function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "PT_svg__a",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#PT_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF2936",
    d: "M0 0h28v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128415",
    fillRule: "evenodd",
    d: "M0 20h10.667V0H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.667,
    cy: 10,
    r: 3.333,
    stroke: "#FAF94F",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.334 8.333c0-.184.149-.333.333-.333h2c.184 0 .333.15.333.333v2.334a1.333 1.333 0 0 1-2.667 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.667,
    cy: 9.666,
    fill: "#1D50B5",
    rx: 0.667,
    ry: 1
  }))));
};
export { SvgPt as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyOCIgaGVpZ2h0PSIyMCIgcng9IjIiIGZpbGw9IndoaXRlIi8+CjxtYXNrIGlkPSJtYXNrMF8xMzkyXzM1NDA1IiBzdHlsZT0ibWFzay10eXBlOmx1bWluYW5jZSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI4IiBoZWlnaHQ9IjIwIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjIwIiByeD0iMiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzEzOTJfMzU0MDUpIj4KPHJlY3Qgd2lkdGg9IjI4IiBoZWlnaHQ9IjIwIiBmaWxsPSIjRkYyOTM2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAyMEgxMC42NjY3VjBIMFYyMFoiIGZpbGw9IiMxMjg0MTUiLz4KPGNpcmNsZSBjeD0iMTAuNjY2NyIgY3k9IjEwLjAwMDIiIHI9IjMuMzMzMzMiIHN0cm9rZT0iI0ZBRjk0RiIgc3Ryb2tlLXdpZHRoPSIxLjMzMzMzIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS4zMzM1IDguMzMzMzNDOS4zMzM1IDguMTQ5MjQgOS40ODI3MyA4IDkuNjY2ODMgOEgxMS42NjY4QzExLjg1MDkgOCAxMi4wMDAyIDguMTQ5MjQgMTIuMDAwMiA4LjMzMzMzVjEwLjY2NjdDMTIuMDAwMiAxMS40MDMgMTEuNDAzMiAxMiAxMC42NjY4IDEyVjEyQzkuOTMwNDUgMTIgOS4zMzM1IDExLjQwMyA5LjMzMzUgMTAuNjY2N1Y4LjMzMzMzWiIgZmlsbD0id2hpdGUiLz4KPGVsbGlwc2UgY3g9IjEwLjY2NjciIGN5PSI5LjY2NjUiIHJ4PSIwLjY2NjY2NyIgcnk9IjEiIGZpbGw9IiMxRDUwQjUiLz4KPC9nPgo8L3N2Zz4K";